define("calendar/components/calendar/settings/notes", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <hr class="u--m__b__0">
  <div class="u--row">
    <div class="u--col__4 u--m__t__md">
      <h5 class="u--text--md u--m__0" data-test-id="calendar-settings-notes-title">
        {{t "calendar.settings.calendar_notes_title"}}
      </h5>
    </div>
    <div class="u--col__8 u--m__t__md">
      <Shared::Ui::CheckboxSwitch
        class="u--p__0 u--m__b"
        @propertyToggled={{@showCalendarNotes}}
        @toggleAction={{@toggleCalendarNotes}}
        @labelText={{t "calendar.settings.calendar_notes_label"}}
      />
    </div>
  </div>
  
  */
  {
    "id": "xHRlpFda",
    "block": "[[[10,\"hr\"],[14,0,\"u--m__b__0\"],[12],[13],[1,\"\\n\"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--col__4 u--m__t__md\"],[12],[1,\"\\n    \"],[10,\"h5\"],[14,0,\"u--text--md u--m__0\"],[14,\"data-test-id\",\"calendar-settings-notes-title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"calendar.settings.calendar_notes_title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--col__8 u--m__t__md\"],[12],[1,\"\\n    \"],[8,[39,1],[[24,0,\"u--p__0 u--m__b\"]],[[\"@propertyToggled\",\"@toggleAction\",\"@labelText\"],[[30,1],[30,2],[28,[37,0],[\"calendar.settings.calendar_notes_label\"],null]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@showCalendarNotes\",\"@toggleCalendarNotes\"],false,[\"t\",\"shared/ui/checkbox-switch\"]]",
    "moduleName": "calendar/components/calendar/settings/notes.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});